module.exports = __webpack_public_path__ + "img/section4_1.24935570.png";